<template>
  <div>
    <h1>CONTACT PAGE</h1>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>